import {getTracerModules} from '@tracer/sdk';
import {usePathname} from 'next/navigation';
import {useEffect} from 'react';

export const useTracePathname = () => {
  const pathname = usePathname();

  useEffect(() => {
    if (pathname) {
      getTracerModules().error?.setErrorKey('pathname', pathname);
      getTracerModules().log?.log('navigate to: ' + pathname);
    }
  }, [pathname]);
};
